import { render, staticRenderFns } from "./LogicQuiz.vue?vue&type=template&id=614ba22f&"
import script from "./LogicQuiz.vue?vue&type=script&lang=js&"
export * from "./LogicQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports